import { render, staticRenderFns } from "./MarketplaceHero.vue?vue&type=template&id=15bc8bc4&scoped=true&"
import script from "./MarketplaceHero.vue?vue&type=script&lang=js&"
export * from "./MarketplaceHero.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceHero.vue?vue&type=style&index=0&id=15bc8bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc8bc4",
  null
  
)

export default component.exports